import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContentsAreaComponent } from './contents-area.component';

@NgModule({
  declarations: [ContentsAreaComponent],
  imports: [CommonModule],
  exports: [ContentsAreaComponent],
})
export class ContentsAreaModule {}
